import { render, staticRenderFns } from "./TodoEditForm.vue?vue&type=template&id=c63a7ede"
import script from "./TodoEditForm.vue?vue&type=script&lang=ts"
export * from "./TodoEditForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports